/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Get's the query string from react router and parses it into URLSearchParams
 * @returns URLSearchParams
 */
export const useQueryParams = () => {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
};
